<template>
  <div class="slide-down">
    <div class="slide-header" @click.stop="changeState">
      <slot name="header" :visible="visible" :change="changeState" />
    </div>
    <div class="droped-content-wrap" :style="style">
      <div ref="content" class="droped-content">
        <slot
          :visible="visible"
          :change="changeState"
          :calc-style="calcStyle"
          :set-auto-height="setAutoHeight"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
interface DropStyle {
  height: string;
  transition?: string;
  overflow: string;
}

export default defineComponent({
  name: 'SlideDown',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    disableClicks: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change'],
  setup(props, { emit }) {
    const visible = ref<boolean>(props.open);
    const needInitiate = ref<boolean>(props.open);
    const content = ref<HTMLElement | null>(null);
    const style = ref<DropStyle>({
      height: props.open ? 'auto' : '0px',
      overflow: 'hidden',
    });

    function calcStyle(): void {
      if (content.value) {
        const height = content.value.getBoundingClientRect().height;

        style.value = {
          transition: `height ${Math.round(height / 2)}ms ${
            visible.value ? 'ease-in' : 'ease-out'
          }`,
          height: (visible.value ? height : 0) + 'px',
          overflow: 'hidden',
        };
      }
    }

    function setAutoHeight(): void {
      if (visible.value) {
        style.value.height = 'auto';
        needInitiate.value = true;
      }
    }

    function changeState(): void {
      if (props.disableClicks) return;
      visible.value = !visible.value;
      emit('change');

      if (needInitiate.value && content.value && content.value.parentElement) {
        content.value.parentElement.style.height =
          content.value.getBoundingClientRect().height + 'px';
        needInitiate.value = false;
        nextTick(calcStyle);
      } else {
        calcStyle();
      }
    }

    return {
      visible,
      changeState,
      content,
      style,
      calcStyle,
      setAutoHeight,
    };
  },
});
</script>

<style scoped lang="scss" src="./SlideDownScss.scss" />
